import { Button } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { useDialog } from "lib/@hooks/useDialog"
import { errorSnackbar } from "lib/snackbar/error-snackbar"
import Iconify from "minimals-template/components/Iconify"
import { CannotApplyComponentDialog } from "../../cannot-apply-component-dialog"
import { getComponentProblems } from "../../controller/get-component-problems"

export function ComponentLibraryFindSimilarButton() {
    const { ok, task, project } = useBoundContext()
    const cannotApplyComponentDialog = useDialog(<CannotApplyComponentDialog />)

    return (
        <Button
            variant="contained"
            color="primary"
            startIcon={<Iconify icon="lucide:text-search" />}
            onClick={handleFindSimilar}
            disabled={!task}
            data-cy="component-library-find-similar-button"
        >
            Find Similar
        </Button>
    )

    async function handleFindSimilar() {
        try {
            const problems = await getComponentProblems({
                projectId: project?.id,
                componentId: task?.id,
                componentVersion: task?.version,
            })
            if (problems?.length) {
                await cannotApplyComponentDialog({ problems })
                return
            }
            ok?.({ componentId: task?.id, componentVersion: task?.version })
        } catch (error) {
            console.error(error)
            errorSnackbar("Unexpected error when checking this component")
        }
    }
}
